<template>
  <Header__WP_Calendar :index="index" :day="day" />
  <Body__WP_Calendar   :index="index" :day="day" />
</template>

<script>
import Header__WP_Calendar from "@/components/wp_planner/calendar/header.calendar.vue";
import Body__WP_Calendar from "@/components/wp_planner/calendar/body.calendar.vue";

export default {
  name: "Day__WP_InfoCard",
  components: { Body__WP_Calendar, Header__WP_Calendar },
  props: ['index', 'day']
}
</script>
